export enum ApiEndpoints {
  mobileAuth = "/mobile-auth",
  user = "/user",
  message = "/message/medical",
  tool = "/tool",
  diagnosis = "/diagnosis",
  user_relationships = "/user-relationships",
  fileStore = "/file-store",
  content = "/content",
  research = "/research",
  medication = "/medication",
  provider = "/provider",
  providerPublic = "/provider-public",
  patientProvider = "/patient-provider",
  providerPatientRequests = "/provider-patient-requests",
  test = "/diagnostic-test",
  vital = "/vital-sign",
  symptom = "/symptom",
  visit = "/visit",
  stream = "/stream",
  userContent = "/user-content",
  userQualification = "/user-qualification",
  group = "/group",
  userGroup = "/user-group",
  ambientConversation = "/ambient-conversation",
  groupChat = "/group-chat",
  groupChatMember = "/group-chat-members",
  messageView = "/message-views",
  mediaReference = "/media-reference",
  errorLog = "/error-log",
  dbInfo = "/db-info",
  auth = "/auth",
  accessRequest = "/access-request",
  storage = "/storage",
  epic = "/epic",
  institution = "/institution",
  patientInstitution = "/patient-institution",
  identity = "/identity",
  templates = "/templates",
  contracts = "/contracts",
  address = "/address",
  notification = "/notification",
  userNotificationPreferences = "/user-notification-preferences",
  schema = "/schema",
  toolCall = "/tool-call",
  messageFeedback = "/message-feedback",
  contactDetails = "/contact-details",
}

export enum VoiceApiEndpoints {
  calls = "/calls",
  agents = "/agents",
  outbound = "/outbound",
}
